export default {
  books: 'Books manager',
  comments: 'Comments manager',
  contacts: 'Contacts manager',
  giftCardTypes: 'Gift card types manager',
  giftCards: 'Gift card manager',
  menus: 'Menus manager',
  pages: 'Pages manager',
  root: 'Superadmin',
  sections: 'Book sections manager',
  settings: 'Settings manager',
  users: 'Users manager',
  widgetAreas: 'Widgets manager',
  selectAtLeastOnePermissionForThisRole: 'Select at least one permission for this role'
}
